/* eslint-disable jira/filename-case */
import React from 'react';
import { render } from 'react-dom';
import DwellApp from '@jira/platform__session-tracker/src/dwell-time/index.tsx';
import { getOrCreateDwellTimeRoot } from '@jira/platform__session-tracker/src/getOrCreateDwellTimeRoot.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/StrictMode.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const getPlaceholder = (placeholderId: string) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const existingPlaceholder = document.getElementById(placeholderId);
	if (existingPlaceholder) {
		return existingPlaceholder;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const div = document.createElement('div');
	div.id = placeholderId;

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (document.body) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		document.body.appendChild(div);
	} else {
		throw new Error(
			'document.body was not found whilst trying to create the dwell component placeholder.',
		);
	}
	return div;
};

const renderDwellTimeComponent = (
	placeholder: string | null,
	sessionId: string | null,
	data: any = {},
): void => {
	if (placeholder && sessionId) {
		const container = getPlaceholder(placeholder);
		const tree = (
			<StrictMode>
				<DwellApp sessionId={sessionId} data={data} />
			</StrictMode>
		);

		if (fg('nike_r19_render_unmount')) {
			getOrCreateDwellTimeRoot(container).render(tree);
		} else {
			render(tree, container);
		}
	}
};

export default renderDwellTimeComponent;
